var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectCalculation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calculation",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Calculation .cls-1 {\n        fill: #ff7600;\n      }\n\n      #Calculation .cls-2 {\n        clip-path: url(#Calculation-clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "Calculation-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,32A16,16,0,1,1,32,16,16,16,0,0,1,16,32M16,1.72A14.28,14.28,0,1,0,30.28,16,14.28,14.28,0,0,0,16,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.807,16.014a4.221,4.221,0,0,1-2.1.548,3.871,3.871,0,0,1-3.1-1.412,3.922,3.922,0,0,1-.864-2.044h-.878v-.837h.768V12.05c0-.165.014-.343.027-.495h-.8V10.7h.919a4.158,4.158,0,0,1,1.029-2.07,3.853,3.853,0,0,1,2.963-1.29,4.564,4.564,0,0,1,1.961.425L22.4,9.046a3.373,3.373,0,0,0-1.537-.371,2.252,2.252,0,0,0-1.741.755,2.634,2.634,0,0,0-.6,1.275h3.594v.85H18.35a2.706,2.706,0,0,0-.028.481v.233h3.786v.837H18.472a2.55,2.55,0,0,0,.591,1.344,2.432,2.432,0,0,0,1.838.741,3.565,3.565,0,0,0,1.618-.411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.27,18.811c-.134,0-.265-.012-.4-.02v1.273h-3.86V17.838H16.8a6.734,6.734,0,0,1-1.629-1.378v.378H11.315V14.612h2.734a6.635,6.635,0,0,1-.313-1H11.315V11.386H13.6a6.614,6.614,0,0,1,.19-1H5.7V24.291H20.7v-5.5c-.145.01-.288.022-.435.022m-9.793,4.48H6.7V21.064h3.779Zm0-3.227H6.7V17.838h3.779Zm0-3.226H6.7V14.611h3.779Zm0-3.226H6.7V11.386h3.779Zm4.7,9.679H11.315V21.064h3.859Zm0-3.227H11.315V17.838h3.859Zm4.7,3.227h-3.86V21.064h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.27,19.363A7.265,7.265,0,1,1,27.534,12.1a7.273,7.273,0,0,1-7.264,7.265m0-13.425a6.161,6.161,0,1,0,6.16,6.16,6.168,6.168,0,0,0-6.16-6.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCalculation);
export default __webpack_public_path__ + "static/media/project-calculation.54a2e3888f2c20d2e5f7fece0deedc4f.svg";
export { ForwardRef as ReactComponent };